const LoadingOpaqueSpinner = () => {
    return (
        <> <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: '9999' }} />
            <div style={{ position: 'absolute', top: '350px', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '1000' }}>
                <div className="fallback-spinner" >
                    <div className="loading">
                        <div className="effect-1 effects"></div>
                        <div className="effect-2 effects"></div>
                        <div className="effect-3 effects"></div>
                    </div>
                </div >
            </div>
        </>
    )
}

export default LoadingOpaqueSpinner
